export type User = {
  userId: string;
  fullName: string;
  email?: string;
  companyId: string | null;
  securityLevel: number;
  accessToken?: string;
};

export enum SecurityLevel {
  None = 0,
  JobCoach = 100,
  CompanyAdmin = 200,
  PlatformAdmin = 1000,
}
